export const emailVerificationStatus = {
    Approved: "Task approved successfully",
    Rejected: "Task rejected successfully",
    Invalid_Token: "Invalid or expired token!",
    Error: "Failed to execute the process",
}

export const getResponseData = (response: any) => {
    switch (response) {
        case emailVerificationStatus.Approved:
            return "Approved";
        case emailVerificationStatus.Rejected:
            return "Rejected";
        case emailVerificationStatus.Invalid_Token:
            return "Invalid Token";
        case emailVerificationStatus.Error:
            return "Error"
        default:
            break;
    }
}